import calls from '@/backend/api-calls'

const state = () => ({
  drawingHighlight: null,
  firstLoad: true,
  loading: false
})

// getters
const getters = {
}

// actions
const actions = {
  getDrawingHighlight: ({commit}, id) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.drawingHighlight.get(id)
        .then(resp => {
          commit("setDrawingHighlight", resp.data);
          commit("setLoading", false);
          commit("setFirstLoad", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  updateDrawingHighlight: ({commit}, { drawingHighlightId, data }) => {
    return new Promise((resolve, reject) => {
      calls.drawingHighlight.put(drawingHighlightId, data)
        .then(resp => {
          commit("setDrawingHighlight", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Drawing highlight successfully updated'
          }, { root: true });
          
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addSvg: ({commit}, { drawingHighlightId, data, params }) => {
    return new Promise((resolve, reject) => {
      calls.drawingHighlight.addMasterSvg(drawingHighlightId, data, params)
        .then(resp => {
          commit("setDrawingHighlight", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Drawing highlight SVG successfully uploaded'
          }, { root: true });
          
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addFile: ({commit}, { data, params }) => {
    return new Promise((resolve, reject) => {
      calls.drawingHighlights.addImage(
        data, params
      ).then(
        resp => {
          commit("insertDrawingHighlightFile", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Drawing highlight file successfully added'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  updateFile: ({commit}, { fileId, data }) => {
    return new Promise((resolve, reject) => {
      calls.drawingHighlightImage.post(fileId, data).then(
        resp => {
          commit("insertUpdatedDrawingHighlightFile", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Drawing highlight file successfully updated'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteFile: ({commit}, fileId) => {
    return new Promise((resolve, reject) => {
      calls.drawingHighlightImage.delete(fileId).then(
        resp => {
          commit("removeDrawingHighlightFile", fileId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Drawing highlight file successfully deleted'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  }
}

// mutations
const mutations = {
  setFirstLoad(state, status) {
    state.firstLoad = status;
  },
  setLoading(state, status) {
    state.loading = status;
  },
  setDrawingHighlight(state, data) {
    state.drawingHighlight = data;
  },
  insertDrawingHighlightFile(state, file) {
    state.drawingHighlight.files.push(file);
  },
  insertUpdatedDrawingHighlightFile(state, data) {
    state.drawingHighlight.files.forEach((file, i) => {
      if (file.id == data.id) {
        state.drawingHighlight.files.splice(i, 1, data);
      }
    })
  },
  removeDrawingHighlightFile(state, fileId) {
    state.drawingHighlight.files.forEach((file, i) => {
      if (file.id == fileId) {
        state.drawingHighlight.files.splice(i, 1);
      }
    });
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}